import { PicklePlan } from 'interfaces/pickle-plan'

export function platformBasePlan(plans: PicklePlan[]) {
  return plans.find((plan) => plan.permalink === 'platform_base')
}

export function platformProPlan(plans: PicklePlan[]) {
  return plans.find((plan) => plan.permalink === 'platform_pro')
}

export function creativePlan(plans: PicklePlan[], dailyTime: number) {
  return plans.find((plan) => plan.permalink === 'creative_services' && plan.dailyTime === dailyTime)
}

export function professionalPlan(plans: PicklePlan[], dailyTime: number) {
  return plans.find((plan) => plan.permalink === 'professional_services' && plan.dailyTime === dailyTime)
}

export function displayPrice(price: number, currency: string) {
  if (price < 0) {
    return `-${currencyToSymbol(currency)}${Math.abs(price).toFixed(2)}`
  } else {
    return `+${currencyToSymbol(currency)}${price.toFixed(2)}`
  }
}

export function displayPlanPrice(plan: PicklePlan) {
  const { price, currency } = plan
  return `${currencyToSymbol(currency)}${Number(price).toFixed(2)}/${plan.period}`
}

export function getTotal(plans: PicklePlan[]) {
  const currency = plans[0]?.currency || 'USD'
  const period = plans[0]?.period || 'monthly'

  const total = plans.reduce((acc, plan) => {
    if (plan?.price) {
      return acc + Number(plan.price)
    }
    return acc
  }, 0)

  return `${currencyToSymbol(currency)}${total.toFixed(2)}/${period}`
}

export function currencyToSymbol(currency: string) {
  switch (currency) {
    case 'USD':
      return '$'
    case 'EUR':
      return '€'
    case 'GBP':
      return '£'
    default:
      return currency
  }
}
